import { render, staticRenderFns } from "./AppPopup.vue?vue&type=template&id=604eceb8&scoped=true&"
import script from "./AppPopup.vue?vue&type=script&lang=ts&"
export * from "./AppPopup.vue?vue&type=script&lang=ts&"
import style0 from "./AppPopup.vue?vue&type=style&index=0&id=604eceb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604eceb8",
  null
  
)

export default component.exports